//@ts-nocheck

const faq = () => {
    const blocks = document.querySelectorAll(".js-faq-block");

    blocks.forEach(block => {
        const searchForm = block.querySelector(".js-faq-form");
        const searchTerm = block.querySelector(".js-search-term");
        const resultsList = block.querySelector(".js-faq-list");
        
        if(!searchForm || !searchTerm || !resultsList) return;

        searchForm.addEventListener("submit", async (e) => {
            e.preventDefault();

            try {
				let formData = new FormData();
				formData.append("action", "llc_load_faqs");
                
                if(searchTerm.value) {
                    formData.append("search_term", searchTerm.value);
                }
                
				block.classList.add("loading");

				const response = await fetch(ajaxurl, {
					method: "POST",
					body: formData,
				});

				const res = await response.json();
                if(res.data) {
                    resultsList.innerHTML = res.data;
                    block.classList.remove("no-results");
                } else {
                    block.classList.add("no-results");
                    resultsList.innerHTML = "";
                }
                
				block.classList.remove("loading");
            } catch(e) {
                console.log(e);
                block.classList.remove("loading");
            }
        })
    });
};

export default faq;
